import React, { useEffect, useState } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Tour } from './components/Tour';
import { Music } from './components/Music';
import { Videos } from './components/Videos';
import { Merch } from './components/Merch';
import { Footer } from './components/Footer';
export function App() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-accent selection:text-brand-white" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        {hash === '#tour' ? <div className="pt-20 min-h-screen" data-id="element-3">
            <Tour data-id="element-4" />
          </div> : hash === '#music' ? <div className="pt-20 min-h-screen" data-id="element-5">
            <Music data-id="element-6" />
          </div> : hash === '#videos' ? <div className="pt-20 min-h-screen" data-id="element-7">
            <Videos data-id="element-8" />
          </div> : hash === '#merch' ? <div className="pt-20 min-h-screen" data-id="element-9">
            <Merch data-id="element-10" />
          </div> : <>
            <Hero data-id="element-11" />
          </>}
      </main>
      <Footer data-id="element-12" />
    </div>;
}